export const getFrtlAliasString = (frtl, data) => {
  if (!frtl || !data) return '';
  const [farmId, roomId, tableId, levelId] = (frtl?.split('.') || []).map(e => parseInt(e));
  const farm = data.farms?.find(f => f.id === farmId);
  const room = data.rooms?.find(r => r.farm_id === farmId && r.id === roomId);
  const table = data.tables?.find(t => t.room_id === roomId && t.id === tableId);
  const level = data.levels?.find(l => l.roomtable_id === tableId && l.id === levelId);

  const farmAlias = farmId === 0 ? '0' : farm?.farm_alias || farmId || '';
  const roomAlias = roomId === 0 ? '0' : room?.room_alias || roomId || '';
  const tableAlias = tableId === 0 ? '0' : table?.table_alias || tableId || '';
  const levelAlias = levelId === 0 ? '0' : level?.level_alias || levelId || '';

  return [farmAlias, roomAlias, tableAlias, levelAlias].filter(alias => alias !== '' && alias !== null && alias !== undefined).join('.');
};
